import React, { Component } from "react";
import { Card, CardBody, Button, Col, Row } from "reactstrap";
import {
  SelectInput,
  TextInput,
  SlButton,
  SlPageTitle,
  SlSectionTitle,
  SlFormEntryRow,
  SlMoneyInput,
  SlSectionLabel,
  SlDropdown,
  SlBusyIndicator,
} from "../editors";
import {
  metadataService,
  userService,
  newLoanStepperService,
  workflowService,
  UserBasisApi,
  ProfileApi,
  SessionService,
  FinancialService,
} from "../../_services";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import validator from "validator";
import { history } from "../../_helpers";
import {
  registrationActions,
  newLoanActions,
  refinanceIncreaseLoanActions,
} from "../../_actions";
import {
  registrationConstants,
  workflowConstants,
  newLoanConstants,
} from "../../_constants";
import Stepper from "./Stepper";
import qs from "query-string";

class FinancialInfoForm extends Component {
  static displayName = FinancialInfoForm.name;

  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      currentStep: "",
      formValue: {
        selectedLanguage: userService.getUserLanguage(),
        primaryIncome: "",
        employer: "",
        years: "",
        months: "",
        address1: "",
        address2: "",
        postalCode: "",
        state: "",
        city: "",
        workNumber: "",
        incomePerPeriod: "",
        payFrequency: "",
        otherIncomeSource: "",
        monthlyOtherIncome: "",
      },
      isEdit: false,
      readOnly: false,
      primaryIncomeError: false,
      employerError: false,
      employerZipError: false,
      employerStateError: false,
      employerCityError: false,
      workPhoneError: false,
      incomePerPeriodError: false,
      payFrequencyError: false,
      otherIncomeSourceError: false,
      monthlyOtherIncomeError: false,
      fieldErrors: [],
      requiredFields: [],
      visibleFields: [],
      otherIncomeSourceOpen: false,
      payFrequencyOpen: false,
      employerStateOpen: false,
      employmentStatusOpen: false,
      isBusy: false,
      readOnlyFields : [],
    };
    this.state.formError = this.formHasError(this.state);
    this.handleInput = this.handleInput.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.getCityState = this.getCityState.bind(this);
    this.formHasError = this.formHasError.bind(this);
    this.handleChangeState = this.handleChangeState.bind(this);
    this.handleRequiredFieldChanges =
      this.handleRequiredFieldChanges.bind(this);
  }
  componentDidMount() {
    if (this.props.source) {
      let newState = {
        ...this.state,
        formValue: { ...this.props.source },
      };
      if (this.props.source.primaryIncome) {
        const { requiredFields, visibleFields } =
          this.handleRequiredFieldChanges(this.props.source.primaryIncome);
        newState = { ...newState, requiredFields, visibleFields };
      }
      this.handleChangeState(newState);
    }
  }

  handleInput = ({ target: { name, value } }) => {
    const formValue = {
      ...this.state.formValue,
      [metadataService.jsonFieldName(name)]: value,
    };
    let newState = {
      ...this.state,
      formValue: formValue,
    };
    if (name === "EmploymentStatus") {
      let requiredFieldChanges = this.handleRequiredFieldChanges(value);
      newState = {
        ...newState,
        ...requiredFieldChanges,
      };
    }
    this.handleChangeState(newState);
  };

  handleRequiredFieldChanges(selectedPrimaryIncomeValue) {
    let selectedValue = parseInt(selectedPrimaryIncomeValue);
    const { requiredFields, visibleFields } =
      FinancialService.FinancialInfoFormFields[selectedValue];
    if (selectedValue === FinancialService.PRIMARY_INCOME_SOURCE_EMPLOYEDFULLTIME 
      || selectedValue === FinancialService.PRIMARY_INCOME_SOURCE_EMPLOYEDPARTTIME
      || selectedValue === FinancialService.PRIMARY_INCOME_SOURCE_SELFEMPLOYED) {
      let formValue = {
        ...this.state.formValue,
        primaryIncome: selectedPrimaryIncomeValue,
        address1: "",
        address2: "",
        postalCode: "",
        state: "",
        city: "",
        workNumber: "",
        years: "",
        months: "",
      };
      return { requiredFields, visibleFields, formValue };
    } else if (selectedValue === FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED) {
      let formValue = {
        ...this.state.formValue,
        primaryIncome: selectedPrimaryIncomeValue,
        employer: "",
        years: "",
        months: "",
        incomePerPeriod: "",
        payFrequency: "",
        address1: "",
        address2: "",
        postalCode: "",
        state: "",
        city: "",
        workNumber: "",
      };
      return { requiredFields, visibleFields, formValue };
    }
  }
  getCityState(zipCode) {
    metadataService.getCityStateByZip(zipCode).then((response) => {
      var data = response.data;
      if (data) {
        const formValue = this.state.formValue;
        let newState = {
          formValue: formValue,
        };

        newState.formValue.city = data.city;
        newState.formValue.state = data.state;

        this.handleChangeState(newState);
      }
    });
  }
  handleOnBlur = ({ target: { name, value } }) => {
    if (name === "PostalCode" && value && value.length === 5) {
      this.getCityState(value);
    }
  };
  handleChangeState(newState) {
    let nextState = { ...this.state, ...newState };
    newState.formError = this.formHasError(nextState);
    this.setState(newState);
  }

  handleSubmit = () => {
    let formError = this.handleValidation();
    if (!formError) {
      const { formValue } = this.state;
      this.props.onSubmit(formValue);
    }
  };

  handleBack = () => {
    this.props.onBack();
  };

  handleValidation = () => {
    let formError = this.formHasError(this.state);
    this.setState((state, props) => {
      return {
        formError: formError,
      };
    });
    return formError;
  };

  formHasError(checkState) {
    let primaryIncomeError = false;
    let employerError = false;
    let employerStreetAddressError = false;
    let employerZipError = false;
    let employerStateError = false;
    let employerCityError = false;
    let workPhoneError = false;
    let incomePerPeriodError = false;
    let payFrequencyError = false;
    let otherIncomeSourceError = false;
    let monthlyOtherIncomeError = false;
    let monthsError = false;
    let yearsError = false;

    let { requiredFields } = checkState;
    let fieldErrors = [];

    this.setState({ fieldErrors: fieldErrors });

    primaryIncomeError = validator.isEmpty(
      checkState.formValue.primaryIncome + ""
    );
     
    employerError =
      requiredFields.includes("EmployerName") &&
      validator.isEmpty(checkState.formValue.employerName + "");
    yearsError =
      requiredFields.includes("Years") &&
      validator.isEmpty(checkState.formValue.years + "");
    monthsError =
      requiredFields.includes("Months") &&
      validator.isEmpty(checkState.formValue.months + "");
    employerStreetAddressError =
      requiredFields.includes("Address1") &&
      validator.isEmpty(checkState.formValue.address1 + "");
    employerZipError =
      requiredFields.includes("PostalCode") &&
      validator.isEmpty(checkState.formValue.postalCode + "");
    employerStateError =
      requiredFields.includes("State") &&
      validator.isEmpty(checkState.formValue.state + "");
    employerCityError =
      requiredFields.includes("City") &&
      validator.isEmpty(checkState.formValue.city + "");
    workPhoneError =
      requiredFields.includes("WorkNumber") &&
      validator.isEmpty(checkState.formValue.workNumber + "");
    incomePerPeriodError =
      requiredFields.includes("IncomePerPeriod") &&
      (validator.isEmpty(checkState.formValue.incomePerPeriod + "") 
      || Number(checkState.formValue.incomePerPeriod + "") <= 0
      );
    payFrequencyError =
      requiredFields.includes("PayFrequency") &&
      validator.isEmpty(checkState.formValue.payFrequency + "");
    otherIncomeSourceError =
      requiredFields.includes("OtherIncomeSource") &&
      validator.isEmpty(checkState.formValue.otherIncomeSource + "");
    monthlyOtherIncomeError =
      requiredFields.includes("MonthlyOtherIncome") &&
      validator.isEmpty(checkState.formValue.monthlyOtherIncome + "");

    if (
      requiredFields.includes("WorkNumber") &&
      checkState.formValue.workNumber.length > 0 &&
      workPhoneError == false
    ) {
      workPhoneError = metadataService.MobileNumberBeginsWithOneOrZero(
        checkState.formValue.workPhoneError
      );
      if (workPhoneError) {
        fieldErrors.push({
          fieldName: "WorkNumber",
          messageName: "MobilePhoneError",
        });
      }
    }

    if (monthlyOtherIncomeError === false) {
      if (
        checkState.formValue.monthlyOtherIncome &&
        validator.isNumeric(checkState.formValue.monthlyOtherIncome + "") &&
        parseFloat(checkState.formValue.monthlyOtherIncome) >
          parseFloat(newLoanConstants.MAX_INCOME_AMOUNT)
      ) {
        fieldErrors.push({
          fieldName: "MonthlyOtherIncome",
          messageName: "MonthlyOtherIncomeInvalid",
        });
        monthlyOtherIncomeError = true;
      }
    }
    if (incomePerPeriodError === false) {
      if (
        checkState.formValue.incomePerPeriod &&
        validator.isNumeric(checkState.formValue.incomePerPeriod + "") &&
       (parseFloat(checkState.formValue.incomePerPeriod) >
          parseFloat(newLoanConstants.MAX_INCOME_AMOUNT) || Number(checkState.formValue.incomePerPeriod) == 0)
      ) {
        fieldErrors.push({
          fieldName: "IncomePerPeriod",
          messageName: "IncomePerPeriodInvalid",
        });
        incomePerPeriodError = true;
      }
    }
    
    return (
      primaryIncomeError ||
      employerError ||
      yearsError ||
      monthsError ||
      employerStreetAddressError ||
      employerZipError ||
      employerStateError ||
      employerCityError ||
      workPhoneError ||
      incomePerPeriodError ||
      payFrequencyError ||
      otherIncomeSourceError ||
      monthlyOtherIncomeError
    );
  }

  toggleReadOnly = (e) => {
    e.preventDefault();
    if (this.state.readOnly) {
      this.setState({ readOnly: false });
    } else {
      this.setState({ readOnly: true });
    }
  };

  openIncomeSourceDropdown = () => {
    this.setState({ otherIncomeSourceOpen: !this.state.otherIncomeSourceOpen });
  };

  openPayFrequencyDropdown = () => {
    this.setState({ payFrequencyOpen: !this.state.payFrequencyOpen });
  };

  openEmployerStateDropdown = () => {
    this.setState({ state: !this.state.state });
  };

  openEmploymentStatusDropdown = () => {
    this.setState({ employmentStatusOpen: !this.state.employmentStatusOpen });
  };
  render() {
    const { isBusy } = this.state;

    return (
      <div className="FinancialInfoForm">
        <div>
          <SlBusyIndicator visible={isBusy} />
          {!isBusy && (
            <Card>
              <CardBody className="noPadBottom">
                <SlSectionLabel sectionName={"EmployerInformation"} />
                <SlFormEntryRow>   
                <SlDropdown
                    Name="EmploymentStatus"
                    value={this.state.formValue.primaryIncome}
                    options={metadataService.getLookup("employmentStatus")}
                    showLabel={true}
                    customLabel={"DescribeEmploymentStatus"}
                    disabled={this.state.readOnly}
                    fieldErrors={this.state.fieldErrors}
                    placeholder={`${metadataService.getLabel(
                      "Select"
                    )} ${metadataService.getLabel("EmploymentStatus")}`}
                    handleChange={this.handleInput}
                    openDropdown={this.openEmploymentStatusDropdown}
                    open={this.state.employmentStatusOpen}
                  />            
                  {/* {this.props.loggedIn !== true ? <SlDropdown
                    Name="EmploymentStatus"
                    value={this.state.formValue.primaryIncome}
                    options={metadataService.getLookup("employmentStatus")}
                    showLabel={true}
                    customLabel={"DescribeEmploymentStatus"}
                    disabled={this.state.readOnly}
                    fieldErrors={this.state.fieldErrors}
                    placeholder={`${metadataService.getLabel(
                      "Select"
                    )} ${metadataService.getLabel("EmploymentStatus")}`}
                    handleChange={this.handleInput}
                    openDropdown={this.openEmploymentStatusDropdown}
                    open={this.state.employmentStatusOpen}
                  />
                  :
                  <TextInput
                  name="EmploymentStatus"
                  value={this.state.formValue.primaryIncome ? metadataService.getLookup("employmentStatus").find(s=>s.value == this.state.formValue.primaryIncome).text : "N/A"}
                  showLabel={true}
                  customLabel={"DescribeEmploymentStatus"}
                  disabled={true}
                />
                } */}
                </SlFormEntryRow>
                {this.state.visibleFields.includes("EmployerName") && (
                  <SlFormEntryRow>
                    <TextInput
                      name="EmployerName"
                      value={this.state.formValue.employerName}
                      onChange={this.handleInput}
                      showLabel={true}
                      customLabel={"WhoIsYourEmployer"}
                      disabled={this.state.readOnly}
                      isRequired={this.state.requiredFields.includes(
                        "EmployerName"
                      )}
                      fieldErrors={this.state.fieldErrors}
                      maxLength={30}
                    />
                  </SlFormEntryRow>
                )}

                {(this.state.visibleFields.includes("Months") ||
                  this.state.requiredFields.includes("Years")) && (
                  <div>
                    <SlSectionLabel sectionName="NumberOfYearsMonthsEmployed" />

                    <SlFormEntryRow>
                      <Row>
                        <Col>
                          <TextInput
                            name="Years"
                            type="number"
                            showLabel={true}
                            disabled={this.state.readOnly}
                            fieldErrors={this.state.fieldErrors}
                            isRequired={this.state.requiredFields.includes(
                              "Years"
                            )}
                            value={
                              this.state.formValue.years
                            }
                            min={0}
                            max={9999}
                            maxLength={4}
                            onChange={this.handleInput}
                          />
                        </Col>
                        <Col>
                          <TextInput
                            name="Months"
                            type="number"
                            value={this.state.formValue.months}
                            disabled={this.state.readOnly}
                            fieldErrors={this.state.fieldErrors}
                            isRequired={this.state.requiredFields.includes(
                              "Months"
                            )}
                            showLabel={true}
                            min={0}
                            max={11}
                            maxLength={2}
                            onChange={this.handleInput}
                          />
                        </Col>
                      </Row>
                    </SlFormEntryRow>
                  </div>
                )}
                {this.state.visibleFields.includes("Address1") && (
                  <div>
                    <SlSectionLabel sectionName="EmployerContactInformation" />

                    <SlFormEntryRow>
                      <TextInput
                        name="Address1"
                        label={metadataService.getFieldNameLabel("Address")}
                        value={this.state.formValue.address1}
                        fieldErrors={this.state.fieldErrors}
                        isRequired={this.state.requiredFields.includes(
                          "Address1"
                        )}
                        showLabel={true}
                        disabled={this.state.readOnly}
                        maxLength={60}
                        onChange={this.handleInput}
                      />
                    </SlFormEntryRow>
                    {/*<SlFormEntryRow>*/}
                    {/*  <TextInput*/}
                    {/*    name="Address2"*/}
                    {/*    value={this.state.formValue.address2}*/}
                    {/*    fieldErrors={this.state.fieldErrors}*/}
                    {/*    isRequired={false}*/}
                    {/*    disabled={this.state.readOnly}*/}
                    {/*    showLabel={true}*/}
                    {/*    maxLength={60}*/}
                    {/*    onChange={this.handleInput}*/}
                    {/*  />*/}
                    {/*</SlFormEntryRow>*/}
                  </div>
                )}
                {this.state.visibleFields.includes("PostalCode") &&
                  this.state.visibleFields.includes("State") && (
                    <SlFormEntryRow>
                      <Row>
                        <Col>
                          <TextInput
                            name="PostalCode"
                            value={this.state.formValue.postalCode}
                            fieldErrors={this.state.fieldErrors}
                            isRequired={this.state.requiredFields.includes(
                              "PostalCode"
                            )}
                            disabled={this.state.readOnly}
                            onChange={this.handleInput}
                            onBlur={this.handleOnBlur}
                            showLabel={true}
                            type="number"
                            maxLength={5}
                          />
                        </Col>
                        <Col>
                          <SlDropdown
                            Name="State"
                            value={this.state.formValue.state}
                            isRequired={this.state.requiredFields.includes(
                              "State"
                            )}
                            options={metadataService.getLookup("state")}
                            disabled={this.state.readOnly}
                            fieldErrors={this.state.fieldErrors}
                            showLabel={true}
                            placeholder={`${metadataService.getLabel(
                              "Select"
                            )}`}
                            handleChange={this.handleInput}
                            openDropdown={this.openEmployerStateDropdown}
                            open={this.state.state}
                          />
                        </Col>
                      </Row>
                    </SlFormEntryRow>
                  )}
                {this.state.visibleFields.includes("City") && (
                  <SlFormEntryRow>
                    <TextInput
                      name="City"
                      value={this.state.formValue.city}
                      fieldErrors={this.state.fieldErrors}
                      showLabel={true}
                      disabled={this.state.readOnly}
                      isRequired={this.state.requiredFields.includes(
                        "City"
                      )}
                      onChange={this.handleInput}
                      maxLength={60}
                    />
                  </SlFormEntryRow>
                )}
                {this.state.visibleFields.includes("WorkNumber") && (
                  <SlFormEntryRow>
                    <TextInput
                      name="WorkNumber"
                      value={this.state.formValue.workNumber}
                      fieldErrors={this.state.fieldErrors}
                      isRequired={this.state.requiredFields.includes(
                        "WorkNumber"
                      )}
                      showLabel={true}
                      disabled={this.state.readOnly}
                      onChange={this.handleInput}
                      type="number"
                      maxLength={10}
                    />
                  </SlFormEntryRow>
                )}
                {this.state.visibleFields.includes("IncomePerPeriod") && (
                  <div>
                    <div>
                      <SlSectionLabel sectionName={"Income"} />
                    </div>
                    <SlFormEntryRow>
                      <SlMoneyInput
                        name="IncomePerPeriod"
                        value={this.state.formValue.incomePerPeriod}
                        fieldErrors={this.state.fieldErrors}
                        onChange={this.handleInput}
                        disabled={this.state.readOnly}
                        isRequired={this.state.requiredFields.includes(
                          "IncomePerPeriod"
                        )}
                        placeholder="$"
                        type="number"
                        showLabel={true}
                      />
                    </SlFormEntryRow>
                  </div>
                )}
                {this.state.visibleFields.includes("PayFrequency") && (
                  <SlFormEntryRow>
                    <SlDropdown
                      Name="PayFrequency"
                      fieldErrors={this.state.fieldErrors}
                      value={this.state.formValue.payFrequency}
                      disabled={this.state.readOnly}
                      options={metadataService.getLookup("incomeFrequency")}
                      isRequired={this.state.requiredFields.includes(
                        "PayFrequency"
                      )}
                      showLabel={true}
                      placeholder={`${metadataService.getLabel("Select")}`}
                      handleChange={this.handleInput}
                      openDropdown={this.openPayFrequencyDropdown}
                      open={this.state.payFrequencyOpen}
                    />
                  </SlFormEntryRow>
                )}
                {this.state.visibleFields.includes("OtherIncomeSource") && (
                  <SlFormEntryRow>
                    <SlDropdown
                      Name="OtherIncomeSource"
                      fieldErrors={this.state.fieldErrors}
                      value={this.state.formValue.otherIncomeSource}
                      options={metadataService.getLookup("otherIncomeSource")}
                      disabled={this.state.readOnly}
                      isRequired={this.state.requiredFields.includes(
                        "OtherIncomeSource"
                      )}
                      showLabel={true}
                      placeholder={`${metadataService.getLabel("Select")}`}
                      handleChange={this.handleInput}
                      openDropdown={this.openIncomeSourceDropdown}
                      open={this.state.otherIncomeSourceOpen}
                    />
                  </SlFormEntryRow>
                )}
                {this.state.visibleFields.includes("MonthlyOtherIncome") && (
                  <SlFormEntryRow>
                    <SlMoneyInput
                      name="MonthlyOtherIncome"
                      value={this.state.formValue.monthlyOtherIncome}
                      fieldErrors={this.state.fieldErrors}
                      onChange={this.handleInput}
                      disabled={this.state.readOnly}
                      isRequired={this.state.requiredFields.includes(
                        "MonthlyOtherIncome"
                      )}
                      placeholder="$"
                      type="number"
                      showLabel={true}
                    />
                  </SlFormEntryRow>
                )}

                {this.props.loggedIn && this.state.readOnly && (
                  <SlFormEntryRow>
                    <div className="text-center">
                      <a href="" onClick={this.toggleReadOnly}>
                        {metadataService.getMessage(
                          "ChangeMyFinancialInformation"
                        )}
                      </a>
                    </div>
                  </SlFormEntryRow>
                )}
              </CardBody>
            </Card>
          )}
        </div>
        <SlFormEntryRow>
          <div className="display-flex">
            <div className="half-width">
              <SlButton
                cssClass={"backBtn"}
                name="Back"
                onClick={this.handleBack}
              />
            </div>
            <div className="half-width">
              <SlButton
                name="Save"
                onClick={this.handleSubmit}
                disabled={this.state.formError}
              />
            </div>
          </div>
        </SlFormEntryRow>
      </div>
    );
  }
}

FinancialInfoForm.propTypes = {
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  source : PropTypes.object
};

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;
    const { language } = state.users;

    return {
        loggedIn,
        language
    };
}

const connectedFinancialInfo = connect(mapStateToProps)(FinancialInfoForm);
export { connectedFinancialInfo as FinancialInfoForm };
